import type { ReactNode } from "react";
import { useCallback, useRef } from "react";

import { HiddenField } from "../forms/controls";
import { KeyboardEventSinkContext } from "./KeyboardEventSinkContext";

export const KeyboardEventSinkProvider = ({ children, id }: { children: ReactNode; id: number }) => {
  const ref = useRef<HTMLInputElement>(null);

  const activate = useCallback(() => ref.current?.focus(), []);
  const deactivate = useCallback(() => ref.current?.blur(), []);

  return (
    <KeyboardEventSinkContext.Provider value={{ activate, deactivate }}>
      <HiddenField ref={ref} tabIndex={-1} readOnly={true} id={`keyboardEventSinkHiddenField-${id}`} />
      {children}
    </KeyboardEventSinkContext.Provider>
  );
};
